import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../axiosConfig";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!phone || !password) {
      setError("Téléphone et mot de passe requis");
      return;
    }

    try {
      setLoading(true);

      // ✅ ROUTE CORRIGÉE
      const res = await api.post("/admin/login", { phone, password });

      // ✅ Stockage token admin
      localStorage.setItem("admin_token", res.data.token);

      // Redirection dashboard admin
      navigate("/admin");
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Erreur lors de la connexion admin"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white shadow-xl rounded-2xl">
        <h1 className="mb-6 text-2xl font-extrabold text-center">
          Connexion Admin
        </h1>

        {error && (
          <div className="p-3 mb-4 text-sm text-red-600 bg-red-100 rounded-lg">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Téléphone admin"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-red-400"
          />

          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-red-400"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-[#f34141] text-white font-bold rounded-xl hover:bg-red-600 transition disabled:opacity-70"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}